import _default from './default.json';
import blue from './blue.json';
import blueSummer from './blue-summer.json';
import crystalMountain from './crystal-mountain.json';
import deerValley from './deer-valley.json';
import juneMountain from './june-mountain.json';
import solitude from './solitude.json';
import solitudeSummer from './solitude-summer.json';
import steamboat from './steamboat.json';
import steamboatSummer from './steamboat-summer.json';
import stratton from './stratton.json';
import strattonSummer from './stratton-summer.json';
import tremblant from './tremblant.json';
import tremblantFr from './tremblant-fr.json';
import tremblantSummer from './tremblant-summer.json';
import tremblantSummerFr from './tremblant-summer-fr.json';

const allResorts = {
  default: _default,
  blue,
  'crystal-mountain': crystalMountain,
  'deer-valley': deerValley,
  'june-mountain': juneMountain,
  'tremblant-fr': tremblantFr,
  solitude,
  steamboat,
  stratton,
  tremblant,
};

const summerResorts = {
  'blue-summer': blueSummer,
  'solitude-summer': solitudeSummer,
  'steamboat-summer': steamboatSummer,
  'stratton-summer': strattonSummer,
  'tremblant-summer': tremblantSummer,
  'tremblant-summer-fr': tremblantSummerFr,
};

export const resortSlug = process.env.VUE_APP_RESORT;
export const defaultConfig = allResorts.default;

export const resortConfig = {
  ...defaultConfig,
  ...allResorts[resortSlug],
  ...summerResorts[`${resortSlug}`],
};

export default { resortSlug, resortConfig, defaultConfig };
